import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateDataModal = ({
  selectedRowsData,
  setselectedRowsData,
  updateHandleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [companyID, setcompanyId] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const renewalDate = moment
    .utc(selectedRowsData?.doc_renewal_dt)
    .format("YYYY-MM-DD");

  function resetFields() {
    setselectedRowsData({
      doc_name: "",
      doc_type: "",
      doc_renewal_dt: "",
      doc_reminder_before: "",
      doc_file_name: "",
      mail_to: "",
      company_id: "",
    });
    setSelectedFile(null); // Reset file state as well
  }

  const setimgfile = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const closeModal = () => {
    $(".custom-close-button-color").trigger("click");
  };

  const handleCompanyChange = (e) => {
    setcompanyId(e.target.value);
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const updateData = async (e) => {
    e.preventDefault();

    var formData = new FormData();
    formData.append("doc_file", selectedFile);
    formData.append("doc_name", selectedRowsData.doc_name);
    formData.append("doc_type", selectedRowsData.doc_type);
    formData.append("doc_renewal_dt", selectedRowsData.doc_renewal_dt);
    formData.append(
      "doc_reminder_before",
      selectedRowsData.doc_reminder_before
    );
    formData.append("id", selectedRowsData.id);
    formData.append("mail_to", selectedRowsData.mail_to);
    formData.append("company_id", companyID);
    let BASE_URL = `${SERVER_URL}/api/compliance/document/${user_id}`;
    try {
      const res = await fetch(BASE_URL, {
        method: "PUT",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const response = await res.json();

      if (res.ok) {
        closeModal();
        setTimeout(() => {
          toast.success(response.message);
        }, 1000);
        getData();
      } else {
        toast.error(response.message);
        getData();
      }
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error("Failed to update data. Please try again.");
    }
  };

  useEffect(() => {
    if (selectedRowsData) {
      setcompanyId(selectedRowsData.company_id);
    }
  }, [selectedRowsData]);

  return (
    <div
      className="modal custom-modal fade"
      id="updateModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Update Compliances
            </h5>
            <button
              type="button"
              className="custom-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <form className="form-sample" onSubmit={updateData}>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Company Name</label>
                          <select
                            className="form-control form-control-lg"
                            onChange={handleCompanyChange}
                            value={companyID}
                            required
                          >
                            <option value="">Select Company Name</option>
                            {company &&
                              company?.length > 0 &&
                              company?.map((item, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <option
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  </React.Fragment>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="name">Document Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="doc_name"
                            id="name"
                            placeholder="Document Name"
                            value={selectedRowsData?.doc_name}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="Document Type">Document Type</label>
                          <input
                            type="text"
                            className="form-control"
                            name="doc_type"
                            id="Document Type"
                            placeholder="Document Type"
                            value={selectedRowsData?.doc_type}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="Document Renewal">
                            Document Renewal Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="doc_renewal_dt"
                            id="Document Renewal"
                            placeholder="Document Renewal Date"
                            value={selectedRowsData?.doc_renewal_dt}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                            min={minDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Document Reminder">
                            Document Reminder
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="doc_reminder_before"
                            id="Document Reminder"
                            placeholder="Document Reminder"
                            value={selectedRowsData?.doc_reminder_before}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="mail">Mail</label>
                          <input
                            type="email"
                            className="form-control"
                            name="mail_to"
                            id="mail"
                            placeholder="Mail"
                            value={selectedRowsData?.mail_to}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>File upload</label>
                          <div className="input-group col-xs-12">
                            <input
                              type="file"
                              name="doc_file"
                              id="fileInputUpdate"
                              className="file-upload-default"
                              onChange={setimgfile}
                              style={{ display: "none" }}
                              autoComplete="off"
                            />
                            <input
                              type="text"
                              className="form-control file-upload-info"
                              value={
                                selectedFile
                                  ? selectedFile.name
                                  : selectedRowsData?.doc_file_name
                              }
                              readOnly
                              placeholder="Upload Image"
                            />
                            <label
                              htmlFor="fileInputUpdate"
                              className="file-upload-browse btn btn-primary"
                              type="button"
                            >
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button className="btn btn-primary mr-2 mt-3" type="submit">
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateDataModal;
